import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button, Col, ConfigProvider, Empty, Form, Image, Input, Row, Select, Spin, Typography } from "antd";
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import { postCreateUnverifiedLead, fetchCities } from "./get-started.model";
import { arabicNumberToEnglish, removeNoneNumeric, saudiMobilePattern } from '../../shared/utils/helper';
import { goToLink } from "../../shared/utils/general.utils";
import ROUTES_ENUM from "../../shared/routes-enum";
import { useAppDispatch, useAppSelector } from "../../shared/hooks/redux";
import 'react-phone-input-2/lib/style.css'
import "./get-started.style.css";
import { resetResultStep } from "../phone-confirmation/phone-confirmation.slice";
import Mobile_logo_ar from '../../assets/imgs/thrivve-logo-ar.svg';
import { ReloadOutlined } from "@ant-design/icons";
import CustomDatePicker from "./partials/birth-date-picker";
import P1 from '../../assets/imgs/P1.png';
import P2 from '../../assets/imgs/P2.png';
import P3 from '../../assets/imgs/P3.png';

let picInterval: any = null;

function GetStartedUi() {
    const [phoneNumber, setPhoneNumber] = useState<any>("+966");
    const [sidePic, setSidePic] = useState<any>(P1);
    const { submitting, cities, loadingCities, errorLoadingCities } = useAppSelector(({ GetStarted }) => GetStarted);
    const dispatch = useAppDispatch();
    const { rid: leadRefId, customerId } = useParams();
    const navigate = useNavigate();
    const { t }: any = useTranslation();
    const [form] = Form.useForm();
    const [searchParams] = useSearchParams();
    // const urlQuery = new URLSearchParams(window.location.search);

    const handleFormSubmit = (values: any) => {
        values.captain_mobile = arabicNumberToEnglish(values?.captain_mobile);
        values.national_id = arabicNumberToEnglish(values?.national_id);
        if (leadRefId ?? searchParams.get("rid")) {
            values.lead_ref = leadRefId ?? searchParams.get("rid");
        }
        values.campaign_name = searchParams.get("campaign_name");
        values.source = searchParams.get("source");
        if (customerId) {
            values.ref = customerId;
        }
        const onSuccessCallback = () => {
            goToLink(navigate, { path: ROUTES_ENUM.CONFIRM_PHONE });
        }
        dispatch(postCreateUnverifiedLead({ ...values, onSuccessCallback }));
    }
    const onIdChange = (e: any) => {
        let formattedValue = removeNoneNumeric(e?.target?.value);
        formattedValue = arabicNumberToEnglish(formattedValue);
        form.setFieldsValue({ national_id: formattedValue });
    }
    const onNumberChange = (e: any) => {
        if (e?.target?.value?.length <= 4) {
            setPhoneNumber('+966');
            form.setFieldsValue({ captain_mobile: '966' });
            return
        }
        let formattedValue: any = e?.target?.value?.replace("+966", "");
        formattedValue = removeNoneNumeric(formattedValue);
        if (formattedValue.replaceAll(" ", "")?.length >= 10) {
            return
        }
        let str: any = formattedValue.split(" ").join("").split("");
        const formatted: any = [];
        while (str.length) {
            for (let i = 0; i < 3 && str.length; i++) {
                formatted.push(str.shift());
            }
            if (str.length) formatted.push(" ");
        }
        setPhoneNumber("+966 " + formatted.join(""));
        form.setFieldsValue({ captain_mobile: "966" + formatted.join("").replaceAll(" ", "") });
    }
    const workingExpOp = [
        { label: t("noExperience"), value: 'لا يوجد خبرة سابقة' },
        { label: t("1 - 3 Months"), value: '1 - 3 شهور' },
        { label: t("3 - 6 Months"), value: '3 - 6  شهور' },
        { label: t("More Than 6 Months"), value: 'أكثر من 6 شهور' },
    ];
    const nationalityOp = [
        { label: "سعودي", value: "saudi" },
        { label: "غير سعودي", value: "non_saudi" },
    ];
    const averageWorkingHoursOp = [
        { label: t("1 - 15"), value: '1 - 15' },
        { label: t("15 - 30"), value: '15 - 30' },
        { label: t("More Than 30 Hours"), value: '30+' },
    ];
    function handleBirthdateChange(date?: "string") {
        form.setFieldsValue({
            date_of_birth: date
        });
    }
    const getCities = useCallback(() => {
        dispatch(fetchCities());
    }, [dispatch]);
    const changeSideBackGroundImage = () => {
        let images = [P1, P2, P3];
        clearInterval(picInterval);
        picInterval = setInterval(() => {
            let randomIndex = Math.floor(Math.random() * images.length)
            let bg = images[randomIndex];
            setSidePic(bg);
        }, 60000);
    }
    useEffect(() => {
        dispatch(resetResultStep());
        dispatch(fetchCities());
    }, [dispatch]);
    useEffect(() => {
        changeSideBackGroundImage();
        return () => clearInterval(picInterval);
    }, []);
    return (
        <Row className="main-guard" justify={"center"} align={"middle"}>
            <Col md={8} sm={0} xs={0} className={"main-guard-side"}>
                <div className={"main-guard-side-relative"}>
                    <div className="main-guard-logo-container" />
                    <Image src={sidePic} alt={"Advertize picture"} preview={false} />
                </div>
            </Col>
            <Col flex={"1"} >
                <Row align={'middle'} justify={"center"} className={"LedReg_Form_Outer relativePosition"}>
                    <Col md={16} sm={22} xs={22}>
                        <Row>
                            <Col lg={0} md={0} sm={24} xs={24}
                                className={`main-guard-mobile-logo`}
                            >
                                <Row justify={"center"}>
                                    <Col>
                                        <Image src={Mobile_logo_ar} alt="Thrivve logo" preview={false} />
                                    </Col>
                                    <Col span={24} className="confirm-info-title">
                                        <Typography.Title level={3}>{t("Confirm Your Contact Info")}</Typography.Title>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Form
                                    labelAlign="left"
                                    layout="vertical"
                                    colon={false}
                                    onFinish={handleFormSubmit}
                                    className={`LedReg_Form`}
                                    form={form}
                                >
                                    <Form.Item
                                        name={"captain_mobile"}
                                        labelCol={{ span: 24 }}
                                        label={
                                            <span>
                                                {t("Phone Number")}
                                            </span>
                                        }
                                        rules={[
                                            { required: true, message: t("requiredPhoneNumber") },
                                            { pattern: saudiMobilePattern, message: t("Please enter a valid phone number") }
                                        ]}
                                        className={"LedReg_flag_mobile"}
                                    >
                                        <PhoneInput
                                            inputStyle={{
                                                width: '100%',
                                                height: '48px',
                                                backgroundColor: '#F5F5F5',
                                                border: '1px solid #dfecf7',
                                                borderColor: '#dfecf7',
                                                direction: 'ltr',
                                                fontSize: 16
                                            }}
                                            inputProps={{
                                                type: "tel",
                                                inputMode: "numeric",
                                                onChange: onNumberChange,
                                                value: phoneNumber,
                                                id: "phoneInputField",
                                            }}
                                            country={"sa"}
                                            onlyCountries={["sa"]}
                                            countryCodeEditable={false}
                                            disableDropdown={true}
                                            buttonStyle={{ borderRightWidth: 0, borderBottomLeftRadius: 5, borderTopLeftRadius: 5, backgroundColor: '#F5F5F5' }}
                                        />
                                    </Form.Item>
                                    <ConfigProvider
                                        renderEmpty={() => (
                                            <>
                                                {loadingCities ? (
                                                    <div className="centered_button">
                                                        <Spin />
                                                    </div>
                                                ) : (
                                                    <Empty
                                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                        description={t("No data found")}
                                                    />
                                                )}
                                                {errorLoadingCities === true ? (
                                                    <div className="centered_button">
                                                        <Button
                                                            style={{ margin: "0 auto" }}
                                                            type="default"
                                                            onClick={getCities}
                                                        >
                                                            <ReloadOutlined />
                                                            {t("Reload data")}
                                                        </Button>
                                                    </div>
                                                ) : null}
                                            </>
                                        )}
                                    >
                                        <Form.Item
                                            name={"city_id"}
                                            label={<span>{t("city")}</span>}
                                            rules={[
                                                { required: true, message: t("City is required") }
                                            ]}
                                        >

                                            <Select
                                                options={cities}
                                                optionLabelProp="label"
                                                className="Custom_Form_Select"
                                                loading={loadingCities}
                                            />
                                        </Form.Item>
                                    </ConfigProvider>
                                    <Form.Item
                                        name={"captain_name"}
                                        labelCol={{ span: 24 }}
                                        label={
                                            <span>{t("Full name")}:</span>
                                        }
                                        rules={[
                                            { required: true, message: t("Full name is required") }
                                        ]}
                                    >
                                        <Input className="Custom_Form_Input" />
                                    </Form.Item>
                                    <Form.Item
                                        name={"national_id"}
                                        labelCol={{ span: 24 }}
                                        label={
                                            <span>{t("ID number")}</span>
                                        }
                                        rules={[
                                            { pattern: /^[٠-٩0-9]+$/i, message: t("IDonlyNumber") },
                                            { required: true, message: t("ID number is required") }
                                        ]}
                                    >
                                        <Input className="Custom_Form_Input" onChange={onIdChange} type="tel" inputMode="numeric" />
                                    </Form.Item>
                                    <Form.Item
                                        name={"nationality"}
                                        label={<span>{t("nationality")}</span>}
                                        rules={[
                                            { required: true, message: t("Nationality is required") }
                                        ]}
                                    >
                                        <Select
                                            options={nationalityOp}
                                            optionLabelProp="label"
                                            className="Custom_Form_Select"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name={"working_time"}
                                        label={<span>{t("expField")}</span>}
                                        rules={[
                                            { required: true, message: t("Experience is required") }
                                        ]}
                                    >
                                        <Select
                                            options={workingExpOp}
                                            optionLabelProp="label"
                                            className="Custom_Form_Select"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name={"average_working_time_type"}
                                        label={
                                            <span>{t("weeklyWorAvgHours")}</span>
                                        }
                                        rules={[
                                            { required: true, message: t("Working hours is required") }
                                        ]}
                                    >
                                        <Select
                                            options={averageWorkingHoursOp}
                                            optionLabelProp="label"
                                            className="Custom_Form_Select"
                                        />
                                    </Form.Item>
                                    <CustomDatePicker onChange={handleBirthdateChange} />
                                    <Button size="large"
                                        loading={submitting}
                                        block type="primary" htmlType="submit"
                                        className={"Terms_Reg_button register"}
                                    >
                                        {t("Register")}
                                    </Button>
                                </Form>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default GetStartedUi;